import sortBy from "lodash/sortBy";
import { Title } from "../../typings/Title";
import { Icon } from "react-migration/components/Icon";
import { useTranslation } from "react-migration/lib/i18n/useTranslation";
import { useMemo } from "react";
import { getTitleOwners } from "../../helpers/getTitleOwners";

type USUnitListProps = {
  units: Title[];
  action: (title?: Title) => void;
};

export const USUnitList = ({ units, action }: USUnitListProps) => (
  <>
    {sortByAddress(units).map((unit: Title) => (
      <UnitListItem key={unit.id} unit={unit} action={action} />
    ))}
  </>
);

export const sortByAddress = (units: Title[]) => {
  return sortBy(units, (unit) => {
    if (Array.isArray(unit.addresses) && unit.addresses.length > 0) {
      return unit.addresses[0];
    }
    return null;
  });
};

type UnitListItemProps = {
  unit: Title;
  action: (unitInfo?: Title) => void;
};

export function UnitListItem({ unit, action }: UnitListItemProps) {
  const { t } = useTranslation();
  const titleOwners = useMemo(() => getTitleOwners(unit).map((owner) => owner?.name), [unit]);

  return (
    <div
      data-testid="unit-list-item"
      onClick={() => action(unit)}
      className="flex justify-between px-2 py-2 gap-x-1 hover:bg-neutral-100 items-center"
      role="button"
    >
      <div className="flex flex-col items-start overflow-hidden">
        {titleOwners.length > 0 ? (
          [...new Set(titleOwners)].slice(0, 2).map((owner) => (
            <div key={owner} className="text-sm font-semibold truncate max-w-full" title={owner}>
              {owner}
            </div>
          ))
        ) : (
          <div className="text-sm font-semibold truncate max-w-full">
            {t("ownership.react.map.sidebar.title_owner.no_owner_info")}
          </div>
        )}
        <div className="text-text-base-tertiary text-xs">{unit.parcel_identifier}</div>
      </div>
      <div className="text-text-base-primary">
        <Icon icon="icon-lt-arrow-right-s-line" />
      </div>
    </div>
  );
}
